import React, { useState } from "react"

const initialState = {
  areaStart: null,
  areaEnd: null,
  priceStart: null,
  priceEnd: null,
  rooms: [],
  floors: [],
  status: [],
  type: [],
}

export const FilterContext = React.createContext(initialState)

const FilterContextProvider = ({ children }) => {
  const [apartmentFilter, setApartmentFilter] = useState(initialState)
  const [priceRange, setPriceRange] = useState(null)
  const [areaRange, setAreaRange] = useState(null)
  const [sortBy, setSortBy] = useState("title")
  const [sortDir, setSortDir] = useState("asc")

  const buildRanges = (price, area) => {
    const updatedRanges = {}

    if (!priceRange) {
      setPriceRange(price)
      updatedRanges.priceStart = price.value.min
      updatedRanges.priceEnd = price.value.max
    }

    if (!areaRange) {
      setAreaRange(area)
      updatedRanges.areaStart = area.value.min
      updatedRanges.areaEnd = area.value.max
    }

    setApartmentFilter({
      ...apartmentFilter,
      ...updatedRanges,
    })
  }

  return (
    <FilterContext.Provider
      value={{
        areaRange,
        setAreaRange,
        priceRange,
        setPriceRange,
        apartmentFilter,
        setApartmentFilter,
        buildRanges,
        sortDir,
        setSortDir,
        sortBy,
        setSortBy,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export default FilterContextProvider
